export const authRoles = {
  admin: ["admin"],
  bar: ["bar"],
  public: ["admin", "bar"]
};
